import React from 'react';
import { Card, Button, Alert } from 'react-bootstrap';

export interface RecalculationResult {
    date: Date;
    message: string;
    isError: boolean;
    timestamp: Date;
}

interface RecalculationResultsListProps {
    results: RecalculationResult[];
    onClear: () => void;
    isLoading?: boolean;
}

export const RecalculationResultsList: React.FC<RecalculationResultsListProps> = ({ 
    results, 
    onClear, 
    isLoading = false 
}) => {
    if (results.length === 0 && !isLoading) {
        return null;
    }

    return (
        <Card className="mt-3">
            <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                    <i className="mdi mdi-check-circle me-2"></i>
                    Resultados del Recálculo
                </h5>
                {results.length > 0 && (
                    <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={onClear}
                    >
                        <i className="mdi mdi-delete me-1"></i>
                        Limpiar
                    </Button>
                )}
            </Card.Header>
            <Card.Body>
                {isLoading && results.length === 0 && (
                    <Alert variant="info" className="mb-0">
                        <i className="mdi mdi-loading mdi-spin me-2"></i>
                        Esperando resultados...
                    </Alert>
                )}
                {results.length > 0 && (
                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <ul className="list-group">
                            {results.map((result, index) => (
                                <li key={index} className="list-group-item">
                                    {result.isError ? (
                                        <span className="text-danger">
                                            <i className="mdi mdi-alert-circle me-2"></i>
                                            {result.message}
                                        </span>
                                    ) : (
                                        <span className="text-success">
                                            <i className="mdi mdi-check-circle me-2"></i>
                                            {result.message}
                                        </span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};



